export default "__VITE_ASSET__DpmEVXkx__"